








































































import Etherpad from "@/components/Etherpad.vue"
import LogosAnswer from "@/components/LogosAnswer.vue"
import settings from "@/settings.coffee"
import utils from '@/utils.coffee'

pas_offset = 240

export default {
    "name": "EstablishmentInfo",
    "components": {Etherpad, LogosAnswer}
    "props": {
        review: Object
        height: false
    }
    "data": ()->
        return {
            "showSignatureDropDown": false
            "toc_h1": []
            "padHeight": (window.innerHeight-pas_offset)+ "px"
            "currentPanel": "pad"
            "panels": ["pad", "logos"]
            "selected": "pad"
        }
    "methods":
        "get_toc": ()->
            data = await @$http.get(settings.etherpad_api_url+"getText?apikey="+settings.etherpad_api_key+"&padID=pad-"+@review.establishment.uid)
        "setHeight": utils.debounce(
            ()->
                @padHeight = (window.innerHeight-pas_offset)+ "px"
                return
            , 500)
        "copySignature": (signature, el)->
            text = signature.content
            textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);

            @$root.$emit('copysig', signature)
            
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            })
            
    "mounted": ()->
        vm = this
        vm.setHeight()
        window.addEventListener('resize', vm.setHeight)


    "beforeDestroy": ()->
        vm = this
        window.addEventListener('resize', vm.setHeight)

}
